module.exports = __webpack_public_path__ + "img/corriente_a_red.a01ccc9d.svg";